export function formatTimeForBrowser(date: Date): string {
    if (!date) return '';
    return date.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit'
    });
}
